//
// import router from '../router/index'
import myAxios from '../functions/myAxios';

import { showSnackbar } from "../components/MySnackbar/globalActions";

const ActionsModule = {
  state: {
    saveData: null,
    editData: null,
  },
  mutations: {
    save(state, payload) {
      state.saveData = payload
    },
    getInfo(state, payload) {
      state.editData = payload
    },
  },
  actions: {
    //
    async save({
      commit
    }, payload) {
      // console.log(payload);
      try {
        let res = await myAxios(payload)
        if (res && res.data) {
          // console.log(res.data);
          if (res.data.insert || res.data.update) {
            commit('save', res.data)
            // router.push('/')
            showSnackbar("اطلاعات با موفقیت ثبت/ویرایش شد", 'success');
          } else if (res.data.invalid) {
            showSnackbar("اطلاعات ارسالی معتبر نیست...", 'warning');
          } else if (res.data.exists) {
            showSnackbar("اطلاعات تکراری...", 'warning');
          } else if (res.data.required) {
            showSnackbar("موارد ستاره دار را پر کنید.", 'warning');
          } else if (res.data.unmodified) {
            showSnackbar("اطلاعات تغییری نکرده...", 'warning');
          } else {
            showSnackbar("خطا از سمت سرور...", 'error');
          }
          // commit('save')
        } else {
          // TODO: set notif
          console.warn(res.data);
        }
      } catch (e) {
        console.error(e);
      }
    },
    //get info from db for edit
    async getInfo({
      commit
    }, payload) {
      // console.log(payload);
      try {
        let res = await myAxios(payload)
        // console.log(res.data);
        if (res && res.data && res.data._id) {
          commit('getInfo', res.data)
        } else {
          console.warn(res);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  getters: {
    saveData(state) {
      // console.log(state.user);
      return state.saveData
    },
    editData(state) {
      // console.log(state.user);
      return state.editData
    }
  }
}

export default ActionsModule
